module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "x9781590207048-6.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Body-Text-No-indent",
    attrs: {
      "id": "toc_marker-7"
    }
  }, [_vm._v("We are not ourselves; actually there is nothing we can call a “self” anymore; we are manyfold, we have as many selves as there are groups to which we belong. . . . The neurotic has overtly a disease from which everybody is suffering . . .")]), _vm._v(" "), _c('p', {
    staticClass: "Author-Spaftr"
  }, [_vm._v("—J. H. van den Berg")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text-No-indent"
  }, [_vm._v("My aim is to bring about a psychic state in which my patient begins to experiment with his own nature—a state of fluidity, change and growth, in which there is no longer anything eternally fixed and hopelessly petrified.")]), _vm._v(" "), _c('p', {
    staticClass: "Author-Spaftr"
  }, [_vm._v("—Carl Jung")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text-No-indent"
  }, [_vm._v("The torch of chaos and doubt—this is what the sage steers by.")]), _vm._v(" "), _c('p', {
    staticClass: "Author-Spaftr"
  }, [_vm._v("—Chuang-Tzu")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text-No-indent"
  }, [_vm._v("I am Zarathustra the godless: I still cook every chance in my pot.")]), _vm._v(" "), _c('p', {
    staticClass: "Author-Spaftr"
  }, [_vm._v("—Nietzsche")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text-No-indent"
  }, [_vm._v("Anybody can be anybody.")]), _vm._v(" "), _c('p', {
    staticClass: "Author-Spaftr"
  }, [_vm._v("—The Dice Man")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4caf85d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781590207048-6.vue
// module id = 78
// module chunks = 0